import { atom, selector } from 'recoil';
import { recoilPersist } from 'recoil-persist';

import { AdminUserRole } from '@constants_common';

const { persistAtom } = recoilPersist();

export type outsourcerPermissionCodes = 'iqra_cloud' | 'sale_case_csv' | 'sale_case_approval';

export type AdminUserData = {
  id: number;
  email: string;
  provider: string;
  uid: string;
  name: string;
  role: AdminUserRole;
  permission_codes: outsourcerPermissionCodes[];
};

export const adminLoginUserDataAtom = atom<AdminUserData | undefined>({
  key: 'adminLoginUserDataAtom',
  default: undefined,
  effects_UNSTABLE: [persistAtom],
});

export const adminUserRoleSelector = selector<AdminUserRole | undefined>({
  key: 'adminUserRoleSelector',
  get: ({ get }) => {
    const adminLoginUserData = get(adminLoginUserDataAtom);
    return adminLoginUserData?.role;
  },
});
